import React from 'react';
import { Link } from 'react-router-dom';

export function TermsOfService() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      {/* Header Section */}
      <div className="bg-white shadow-sm border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-6 py-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-2">
              Terms of Service
            </h1>
            <p className="text-sm text-gray-600 mb-4">KOLCO COMMERCE PRIVATE LIMITED</p>
            <div className="inline-flex items-center px-4 py-2 bg-blue-50 rounded-full">
              <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
              <p className="text-sm font-medium text-gray-700">Last updated: December 2024</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-5xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
          <div className="p-8 md:p-12 space-y-10">
            
            {/* Section 1 */}
            <section className="border-l-4 border-blue-500 pl-6 bg-gradient-to-r from-blue-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-blue-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                Acceptance of Terms
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                By accessing and using the AEO Platform operated by KOLCO COMMERCE PRIVATE LIMITED ("Service"), you accept and agree to be bound by the terms 
                and provision of this agreement.
              </p>
            </section>

            {/* Section 2 */}
            <section className="border-l-4 border-indigo-500 pl-6 bg-gradient-to-r from-indigo-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-indigo-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                Use License
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                Permission is granted to temporarily download one copy of AEO Platform per device for personal, 
                non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.
              </p>
            </section>

            {/* Section 3 */}
            <section className="border-l-4 border-purple-500 pl-6 bg-gradient-to-r from-purple-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-purple-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                Service Description
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                AEO Platform provides AI-powered customer support solutions including FAQ generation, 
                chat widgets, and analytics tools for businesses.
              </p>
            </section>

            {/* Section 4 */}
            <section className="border-l-4 border-emerald-500 pl-6 bg-gradient-to-r from-emerald-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-emerald-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">4</span>
                User Accounts
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                You are responsible for safeguarding the password and for all activities that occur under your account. 
                You agree not to disclose your password to any third party.
              </p>
            </section>

            {/* Section 5 */}
            <section className="border-l-4 border-red-500 pl-6 bg-gradient-to-r from-red-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-red-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">5</span>
                Prohibited Uses
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg mb-4">You may not use our service:</p>
              <ul className="space-y-3 text-gray-700 text-lg">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-red-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  For any unlawful purpose or to solicit others to unlawful acts
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-red-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-red-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  To infringe upon or violate our intellectual property rights or the intellectual property rights of others
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-red-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  To harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate
                </li>
              </ul>
            </section>

            {/* Section 6 */}
            <section className="border-l-4 border-amber-500 pl-6 bg-gradient-to-r from-amber-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-amber-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">6</span>
                Service Availability
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                We reserve the right to withdraw or amend our service, and any service or material we provide via 
                the website, in our sole discretion without notice.
              </p>
            </section>

            {/* Section 7 */}
            <section className="border-l-4 border-orange-500 pl-6 bg-gradient-to-r from-orange-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-orange-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">7</span>
                Limitation of Liability
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                In no event shall AEO Platform, nor its directors, employees, partners, agents, suppliers, 
                or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages.
              </p>
            </section>

            {/* Section 8 */}
            <section className="border-l-4 border-teal-500 pl-6 bg-gradient-to-r from-teal-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-teal-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">8</span>
                Contact Information
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                If you have any questions about these Terms of Service, please {' '}
                <a href="https://mail.google.com/mail/?view=cm&fs=1&to=honey@fastpr.co&su=Enterprise%20Package%20Inquiry&body=Hi%20Team%2C%0A%0AI%20am%20interested%20in%20learning%20more%20about%20your%20enterprise%20packages%20and%20custom%20integrations.%20Please%20share%20the%20details.%0A%0ARegards%2C%0A%5BYour%20Name%5D"   target="_blank"
  rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700 font-semibold underline decoration-2 underline-offset-2">
                  contact us
                </a>
              </p>
            </section>
          </div>
        </div>

        {/* Navigation */}
        <div className="mt-8 text-center">
          <Link 
            to="/" 
            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-full hover:from-blue-700 hover:to-indigo-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export function RefundPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      {/* Header Section */}
      <div className="bg-white shadow-sm border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-6 py-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-2">
              Refund Policy
            </h1>
            <p className="text-sm text-gray-600 mb-4">KOLCO COMMERCE PRIVATE LIMITED</p>
            <div className="inline-flex items-center px-4 py-2 bg-blue-50 rounded-full">
              <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
              <p className="text-sm font-medium text-gray-700">Last updated: August 24, 2025</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-5xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
          <div className="p-8 md:p-12 space-y-10">

            {/* Intro */}
            <section className="border-l-4 border-blue-500 pl-6 bg-gradient-to-r from-blue-50 to-transparent p-6 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed text-lg">
                At KOLCO COMMERCE PRIVATE LIMITED (doing business as Uttik), we are committed to providing high-quality AI-powered customer support solutions through our AEO (Answer Engine Optimization) Platform. Our refund policy is designed to ensure fairness and transparency for our users. Please review the details below to understand the conditions for refunds, cancellations, and related processes.
              </p>
            </section>

            {/* Section 1: Eligibility for Refunds */}
            <section className="border-l-4 border-indigo-500 pl-6 bg-gradient-to-r from-indigo-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-indigo-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                Eligibility for Refunds
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg mb-4">Refunds may be available under the following circumstances:</p>
              <ul className="space-y-3 text-gray-700 text-lg">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-indigo-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>Service Issues:</strong> If there is a technical issue preventing you from accessing or using our AI-powered tools (e.g., FAQ generation, chat widgets, or analytics) as described, and we are unable to resolve it within a reasonable timeframe.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-indigo-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>Dissatisfaction During Trial Period:</strong> If you are not satisfied with the service during any applicable trial period, you may request a full refund.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-indigo-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>Billing Errors:</strong> In cases of overbilling or duplicate charges due to errors on our end.
                  </span>
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed text-lg mt-4">
                <em>Note:</em> Due to the digital nature of our services, refunds are not typically available for subscriptions once the service has been accessed or used beyond the trial period, unless required by law.
              </p>
            </section>

            {/* Section 2: Refund Timeframe */}
            <section className="border-l-4 border-purple-500 pl-6 bg-gradient-to-r from-purple-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-purple-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                Refund Timeframe
              </h2>
              <ul className="space-y-3 text-gray-700 text-lg">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>Trial Period Refunds:</strong> Requests must be made within the duration of the trial period (if offered, typically 14-30 days; check your subscription details).
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>General Refunds:</strong> For other eligible cases, requests must be submitted within 30 days of the charge date or issue occurrence.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>Subscription Services:</strong> Refunds for ongoing subscriptions are not pro-rated unless specified in your plan terms.
                  </span>
                </li>
              </ul>
            </section>

            {/* Section 3: Cancellation Policy */}
            <section className="border-l-4 border-emerald-500 pl-6 bg-gradient-to-r from-emerald-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-emerald-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                Cancellation Policy
              </h2>
              <ul className="space-y-3 text-gray-700 text-lg">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-emerald-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  You may cancel your subscription at any time through your account dashboard or by contacting support.
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-emerald-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Cancellations take effect at the end of the current billing cycle, and you will retain access until then.
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-emerald-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  No refunds will be issued for partial months or unused portions of the subscription period, except during trial periods or in cases of service issues.
                </li>
              </ul>
            </section>

            {/* Section 4: Refund Process */}
            <section className="border-l-4 border-red-500 pl-6 bg-gradient-to-r from-red-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-red-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">4</span>
                Refund Process
              </h2>
              <ol className="space-y-3 text-gray-700 text-lg list-decimal ml-6">
                <li>
                  <strong>Contact Support:</strong> Email us at <a href="mailto:support@uttik.com" className="text-red-600 hover:text-red-700 font-semibold underline decoration-2 underline-offset-2">support@uttik.com</a> with your account details, order/subscription ID, and a detailed explanation of the reason for your request.
                </li>
                <li>
                  <strong>Review:</strong> Our team will review your request and respond within 3-5 business days.
                </li>
                <li>
                  <strong>Approval and Processing:</strong> If approved, refunds will be issued to the original payment method within 7-10 business days. The time for the refund to appear in your account depends on your payment provider.
                </li>
              </ol>
            </section>

            {/* Section 5: Refund Options */}
            <section className="border-l-4 border-amber-500 pl-6 bg-gradient-to-r from-amber-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-amber-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">5</span>
                Refund Options
              </h2>
              <ul className="space-y-3 text-gray-700 text-lg">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-amber-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  <span><strong>Monetary Refunds:</strong> Issued to the original payment method (e.g., credit card, PayPal).</span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-amber-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  <span><strong>Account Credit:</strong> Alternatively, we may offer credit toward future services at your discretion.</span>
                </li>
              </ul>
            </section>

            {/* Section 6: Non-Refundable Items */}
            <section className="border-l-4 border-orange-500 pl-6 bg-gradient-to-r from-orange-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-orange-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">6</span>
                Non-Refundable Items
              </h2>
              <ul className="space-y-3 text-gray-700 text-lg">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Subscriptions after the trial period or once services have been substantially used.
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Custom configurations or one-time setup fees.
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Any third-party fees or integrations not directly managed by Uttik.
                </li>
              </ul>
            </section>

            {/* Section 7: Warranties and Limitations */}
            <section className="border-l-4 border-teal-500 pl-6 bg-gradient-to-r from-teal-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-teal-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">7</span>
                Warranties and Limitations
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                We provide our services "as is" without warranties of any kind, except as outlined in our Terms of Service. For full details on warranties, limitations of liability, and user obligations, please refer to our Terms of Service.
              </p>
            </section>

            {/* Section 8: Contact Us */}
            <section className="border-l-4 border-blue-500 pl-6 bg-gradient-to-r from-blue-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-blue-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">8</span>
                Contact Us
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                If you have questions about this refund policy or need assistance: Email <a href="mailto:support@uttik.com" className="text-blue-600 hover:text-blue-700 font-semibold underline decoration-2 underline-offset-2">support@uttik.com</a> or <a href="mailto:hello@fasrtpr.co" className="text-blue-600 hover:text-blue-700 font-semibold underline decoration-2 underline-offset-2">hello@fasrtpr.co</a>. Website: Submit a ticket through your account dashboard.
              </p>
            </section>
          </div>
        </div>

        {/* Navigation */}
        <div className="mt-8 text-center">
          <Link 
            to="/" 
            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-600 text-white font-semibold rounded-full hover:from-blue-700 hover:to-blue-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      {/* Header Section */}
      <div className="bg-white shadow-sm border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-6 py-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-2">
              Privacy Policy
            </h1>
            <p className="text-sm text-gray-600 mb-4">KOLCO COMMERCE PRIVATE LIMITED</p>
            <div className="inline-flex items-center px-4 py-2 bg-blue-50 rounded-full">
              <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
              <p className="text-sm font-medium text-gray-700">Last updated: December 2024</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-5xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
          <div className="p-8 md:p-12 space-y-10">
            
            {/* Section 1 */}
            <section className="border-l-4 border-blue-500 pl-6 bg-gradient-to-r from-blue-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-blue-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                Information We Collect
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg mb-4">We collect information you provide directly to us, such as when you:</p>
              <ul className="space-y-3 text-gray-700 text-lg">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Create an account
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Upload content to our platform
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Use our AI-powered features
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Contact us for support
                </li>
              </ul>
            </section>

            {/* Section 2 */}
            <section className="border-l-4 border-blue-500 pl-6 bg-gradient-to-r from-blue-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-blue-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                How We Use Your Information
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg mb-4">We use the information we collect to:</p>
              <ul className="space-y-3 text-gray-700 text-lg">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Provide, maintain, and improve our services
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Process transactions and send related information
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Send technical notices and support messages
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Respond to comments, questions, and customer service requests
                </li>
              </ul>
            </section>

            {/* Section 3 */}
            <section className="border-l-4 border-indigo-500 pl-6 bg-gradient-to-r from-indigo-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-indigo-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                Information Sharing
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                We do not sell, trade, or otherwise transfer your personal information to third parties. 
                This does not include trusted third parties who assist us in operating our website or 
                conducting our business.
              </p>
            </section>

            {/* Section 4 */}
            <section className="border-l-4 border-emerald-500 pl-6 bg-gradient-to-r from-emerald-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-emerald-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">4</span>
                Data Security
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                We implement appropriate security measures to protect against unauthorized access, 
                alteration, disclosure, or destruction of your personal information.
              </p>
            </section>

            {/* Section 5 */}
            <section className="border-l-4 border-teal-500 pl-6 bg-gradient-to-r from-teal-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-teal-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">5</span>
                Data Retention
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                We retain your personal information for as long as necessary to provide our services 
                and fulfill the purposes outlined in this privacy policy.
              </p>
            </section>

            {/* Section 6 */}
            <section className="border-l-4 border-orange-500 pl-6 bg-gradient-to-r from-orange-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-orange-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">6</span>
                Your Rights
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg mb-4">You have the right to:</p>
              <ul className="space-y-3 text-gray-700 text-lg">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Access your personal information
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Correct inaccurate information
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Request deletion of your information
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mt-3 mr-3 flex-shrink-0"></span>
                  Object to processing of your information
                </li>
              </ul>
            </section>

            {/* Section 7 */}
            <section className="border-l-4 border-amber-500 pl-6 bg-gradient-to-r from-amber-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-amber-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">7</span>
                Cookies
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                We use cookies to enhance your experience, gather general visitor information, 
                and track visits to our website.
              </p>
            </section>

            {/* Section 8 */}
            <section className="border-l-4 border-blue-500 pl-6 bg-gradient-to-r from-blue-50 to-transparent p-6 rounded-r-lg">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                <span className="bg-blue-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">8</span>
                Contact Us
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                If you have any questions about this Privacy Policy, please {' '}
                <a href="https://mail.google.com/mail/?view=cm&fs=1&to=honey@fastpr.co&su=Enterprise%20Package%20Inquiry&body=Hi%20Team%2C%0A%0AI%20am%20interested%20in%20learning%20more%20about%20your%20enterprise%20packages%20and%20custom%20integrations.%20Please%20share%20the%20details.%0A%0ARegards%2C%0A%5BYour%20Name%5D"   target="_blank"
  rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 font-semibold underline decoration-2 underline-offset-2">
                  contact us
                </a>
              </p>
            </section>
          </div>
        </div>

        {/* Navigation */}
        <div className="mt-8 text-center">
          <Link 
            to="/" 
            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-full hover:from-blue-700 hover:to-indigo-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}